import React from 'react';
import styled from 'styled-components';

import UnstyledBlur from '../Blur';

import Toolbar from './Toolbar';
import Title from './Title';
import Content from './Content';
import Footer from './Footer';

function Card(props) {
  const {overlay} = props;
  let {children} = props;

  children = React.Children.map(children, child => {
    if (child && typeof child === 'object') {
      // Automatically pass the active prop down to the content so that padding can be adjusted.
      if (child.type === Content) {
        return React.cloneElement(child, {
          active: props.active,
          focusable: props.focusable
        });
      }
      else if (child.type === Footer) {
        return React.cloneElement(child, {
          active: props.active,
          focusable: props.focusable
        });
      }
    }

    return child;
  });

  return (
    <Container {...props}>
      <Blur blurred={!!overlay}>{children}</Blur>
      {overlay && <CardOverlay>{overlay}</CardOverlay>}
    </Container>
  );
}

const Container = styled.div`
  background: #fff;
  border-radius: 0.625rem;
  overflow: hidden;
  box-shadow: 0 0.125rem 0 rgba(90, 97, 105, 0.11),
              0 0.25rem 0.5rem rgba(90, 97, 105, 0.12),
              0 0.625rem 0.625rem rgba(90, 97, 105, 0.06),
              0 0.4375rem 4.375rem rgba(90, 97, 105, 0.1);

  ${props => {
    if (props.overlay) {
      return `
        position: relative;
      `;
    }
  }}

  // Variant of the card when it is focused.
  ${props => {
    if (props.active) {
      return `border: 0.125rem solid #0049ee;`;
    }
  }}

  ${props => {
    if (props.focusable) {
      return `
        :focus-within {
          border: 0.125rem solid #0049ee;
        }
      `;
    }
  }}

  // Variant of the card with a top border.
  ${props => {
    if (props.borderTop) {
      return `border-top: 0.25rem solid #0049ee;`;
    }
  }}
`;

const Blur = styled(UnstyledBlur)`
  height: 100%;
`;

const CardOverlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  background: ${() => {
    if (navigator.userAgent.indexOf("MSIE ") > -1 || navigator.userAgent.indexOf("Trident/") > -1) {
      return '#fff';
    }

    return 'rgba(255, 255, 255, 0.5)';
  }};
  display: flex;
  align-items: center;
  justify-content: center;
`;

Card.Toolbar = Toolbar;
Card.Title = Title;
Card.Content = Content;
Card.Footer = Footer;
export default Card;